import socket from 'socket.io-client'

import {SOCKET} from 'actions/endpoint'

const io = socket(SOCKET)

export default io
